import Vue from 'vue';

const state = {
  tncUrl: null,
  ppUrl: null,
  tosToken: null,
  loaded: false,
};


const actions = {
  GET_VERSIONED_CONTENT () {
    const gql = window.gql;
    if (!gql) {
      this.commit('versionedContent/FALLBACK');
      return;
    }
    if(this.state.versionedContent.loaded) {
      return;
    }
    this.commit('versionedContent/FETCHING')
    gql(`
    query {
      getVersionTokenForContent {
        tosToken: versionToken
        content {
          type
          url
        }
      }
    }`)().then(({ getVersionTokenForContent: { content, tosToken } }) =>  {
      this.commit('versionedContent/FETCHED', {
        tosToken,
        tncUrl: content.find(c => c.type === 'TERMS_AND_CONDITIONS').url,
        ppUrl: content.find(c => c.type === 'PRIVACY_POLICY').url
      })
    }).catch(e => {
      console.error('Failed to fetch terms.  Falling back:', e);
      this.commit('versionedContent/FALLBACK')
    });
  }
}

const mutations = {
  FETCHING (state) {
    state.loaded = false;
    state.tncUrl = null;
    state.tosToken = null;
    state.ppUrl = null;
  },
  FETCHED (state, result) {
    state.tosToken = result.tosToken;
    state.tncUrl = result.tncUrl
    state.ppUrl = result.ppUrl
    state.loaded = true;
  },
  FALLBACK (state) {
    state.tosToken = null;
    state.tncUrl = '/terms';
    state.ppUrl = '/privacy';
    state.loaded = true;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
